/**
 * <TableSetting
 *		// please describe props here
 *	/>
 *
 * This is the setting cell where we nest controlling functions
 *
		{ title: "加入班级", onClick: (opts)=>{ console.log(opts); }, isShow: ()=> {} },
		{ title: "签到", onClick: (opts)=>{ console.log(opts); } },
		{ title: "更多", id: "table1-modify", onClick: (opts)=>{ console.log(opts); }, dropdown: [
			{ title: "修改", onClick: (opts)=>{ console.log(opts); } },
			{ title: "归档", onClick: (opts)=>{ console.log(opts); } },
		] },
 *
 * @parent Table
 * @stateless
 */
import React, { PropTypes } from 'react';
import { MenuItem } from 'react-bootstrap'
import DropdownButton from 'components/UI/DropdownButton'
import classnames from 'classnames'
import cloneDeep from 'lodash/cloneDeep';

class TableSetting extends React.Component {
  constructor(props) {
		super(props);
		this._handleCtrlOnClick = this._handleCtrlOnClick.bind(this);
	}

	render() {
		const {
      settings,
      settingsModifier,
			data,
			fields,
			settingWidth,
			trData,
			trIndex,
      tbodyIndex,
      dropdownGuideWidth,
      dropdownGuideHeight,
		} = this.props;

    // NOTE: make sure these settings are still
    let thisSettings;
    if (typeof settingsModifier == 'function') {
      thisSettings = cloneDeep(settings);
      thisSettings = settingsModifier(thisSettings, this.props)
    } else {
      thisSettings = settings;
    }

		return (
			<td className="table-setting" style={{ width: settingWidth }}>
				{thisSettings.map((ctrl, idx)=>{
					const opts = {
						ctrl,
						trData,
						trIndex,
						data,
						fields,
						tbodyIndex
					};

					let disabled = false;
					if (typeof ctrl.isDisabled == "function" && ctrl.isDisabled(opts)) {
						disabled = true;
          }

          let hasAlert;
          if (typeof ctrl.hasAlert == 'function') {
            hasAlert = ctrl.hasAlert(opts);
          } else {
            hasAlert = ctrl.hasAlert;
          }

					if (Array.isArray(ctrl.dropdown)) {
						if (!ctrl.id) {
							throw new Error("Error: Missing id in dropdown button while creating settings for a table. Please add a dropdown id");
						}
						return (
								<span key={idx} >
									<DropdownButton dropdownGuideWidth={dropdownGuideWidth} dropdownGuideHeight={dropdownGuideHeight} disabled={disabled} id={ctrl.id} bsStyle='link' title={this._getDropdownTitle(ctrl, opts)} id={ctrl.id} noCaret>
										{this._getDropdownMenuItems(opts)}
                  </DropdownButton>
                  {hasAlert == true && <div className='table-settings-btn-alert'></div>}
								</span>
						)
					} else {
          
            let ctrlTitle;

            if (typeof ctrl.title === 'function') {
              ctrlTitle = ctrl.title(opts);
            } else {
              ctrlTitle = ctrl.title;
            }
          
            return (
              <span>
                <button className='btn-link' disabled={disabled} onClick={(event)=>{
                  let params = { ctrl, trData, trIndex, data, fields, tbodyIndex };
                  this._handleCtrlOnClick(ctrl, params, event);
                  }}>{ctrlTitle}</button>
                {hasAlert == true && <div className='table-settings-btn-alert'></div>}
              </span>
						);
					}
				})}
			</td>
		);
	}

	_handleCtrlOnClick(ctrl, params, event) {

		let fnName = ctrl.onClickFunctionName;
		let { settingFunctions } = this.props;
		if (typeof(ctrl.onClick) == "function") {
			ctrl.onClick(params, event);
		}

		if (settingFunctions && typeof(fnName) == "string" && typeof(settingFunctions[fnName]) == "function") {
			settingFunctions[fnName](params, event)
		}

	}

  _getDropdownTitle(ctrl, opts) {
    const {
      hideDropdownCaret,
      dropdownCaretIcon = "fa icon-angle-down",
    } = this.props;

    let ctrlTitle;

    if (typeof ctrl.title === 'function') {
      ctrlTitle = ctrl.title(opts);
    } else {
      ctrlTitle = ctrl.title;
    } 

		return (<span>{ctrlTitle}{hideDropdownCaret !== true && <i className={classnames(dropdownCaretIcon, "dropdown-caret")} />}</span>);
	}

	_getDropdownMenuItems(opts) {
    const { ctrl: parentCtrl, trData, trIndex, data, fields, tbodyIndex } = opts;

		return parentCtrl.dropdown.map((ctrl, childIdx)=>{

      let disabled;
      if (typeof(ctrl.isDisabled) == 'function') {
        disabled = ctrl.isDisabled(opts);
      }

			return (
			<MenuItem
				eventKey={childIdx}
				key={childIdx}
        disabled={disabled}
				onClick={(event)=>{
          if(!disabled){
            let params = { ctrl, parentCtrl, trData, trIndex, data, fields, tbodyIndex };
            this._handleCtrlOnClick(ctrl, params, event);
          }
				}}>
						{ctrl.title}
					</MenuItem>
				);
		});
	}

}

export default TableSetting;



// WEBPACK FOOTER //
// ./src/components/UI/Table/TableSetting.js